export default "__VITE_ASSET__DHd8LJyE__"